import {createAction, props} from '@ngrx/store';
import {ParametryZbioruUszkodzenPrzedmiotow} from './zbiorUszkodzenPrzedmiotow';

export enum ZbiorUszkodzenPrzedmiotowActionTypes {
  AKTUALIZUJ_ZBIOR_USZKODZEN_PRZEDMIOTU = '[ZbiorUszkodzenPrzedmiotow] aktualizuj',
  AKTUALIZUJ_PARAMETRY_PRZEDMIOTU = '[ZbiorUszkodzenPrzedmiotow] aktualizuj parametry',
  USUN_ZBIOR_USZKODZEN_PRZEDMIOTU = '[ZbiorUszkodzenPrzedmiotow] usun',
  AKTUALIZUJ_KWOTE_ROSZCZENIA = '[ZbiorUszkodzenPrzedmiotow] aktualizuj kwote roszczenia',
}

export const aktualizujZbiorUszkodzenPrzedmiotow = createAction(
  ZbiorUszkodzenPrzedmiotowActionTypes.AKTUALIZUJ_ZBIOR_USZKODZEN_PRZEDMIOTU,
  props<{przedmiotId: number, zbiorUszkodzenId: string}>()
);

export const aktualizujParametryPrzedmiotu = createAction(
  ZbiorUszkodzenPrzedmiotowActionTypes.AKTUALIZUJ_PARAMETRY_PRZEDMIOTU,
  props<{przedmiotId: number, parametry: ParametryZbioruUszkodzenPrzedmiotow}>()
);

export const usunZbiorUszkodzenPrzedmiotow = createAction(
  ZbiorUszkodzenPrzedmiotowActionTypes.USUN_ZBIOR_USZKODZEN_PRZEDMIOTU,
  props<{przedmiotId: number, zbiorUszkodzenId: string}>()
);

export const aktualizujKwoteRoszczenia = createAction(
  ZbiorUszkodzenPrzedmiotowActionTypes.AKTUALIZUJ_KWOTE_ROSZCZENIA,
  props<{przedmiotId: number, kwotaRoszczenia: number | undefined}>()
);
